import { FILTERABLE_ENTITY_TYPES } from './options';

export enum CustomConditionKeys {
  triggeredActivity = 'triggered_activity',
}

export const CustomConditionKeyConfig = {
  [CustomConditionKeys.triggeredActivity]: {
    entityType: FILTERABLE_ENTITY_TYPES.leadActivity,
    label: 'Triggered Activity',
    value: 'triggered_activity',
  },
};

export const customConditionKeys = Object.values(CustomConditionKeys) as CustomConditionKeys[];
